import React, {useEffect, useRef, useState} from "react";
import {View, TouchableOpacity, Text, StyleSheet} from "react-native";
import {Color, globalFontStyle, globalStyle} from "../../../assets";
import Header from "../../../commonComponents/Header";

import {
  getLoginRoute,
  isMobile,
  trackMoengageEvent,
} from "../../../utils/commonMethods";

import {useSafeAreaInsets} from "react-native-safe-area-context";

import RewardsEvents from "../../rewards/childComponents/rewardsEvents";

const Tokens = ({route, navigation}) => {
  const insets = useSafeAreaInsets();

  return (
    <>
      <View
        style={[
          {
            backgroundColor: Color.bgWhite,

            paddingTop: insets.top,
            paddingLeft: insets.left,
            paddingRight: insets.right,
          },
          isMobile() ? globalStyle.scroll_webFix : {},
        ]}>
        <Header
          isInternalPage={false}
          navigation={navigation}
          pageName={"Token Events"}
          backGroundColor={"#FFFFFF"}
          translate={true}
        />

        <View style={{flex: 1, paddingHorizontal: 16}}>
          <RewardsEvents navigation={navigation} />
        </View>
      </View>
    </>
  );
};

export default Tokens;

const styles = StyleSheet.create({});
